// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullScreenCallViewPanel__container-a11066 {
  height: 40px;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  padding: 12px 24px;
  background: linear-gradient(180deg, rgba(24, 25, 31, 0) 0%, rgba(24, 25, 31, 0.7) 227.27%);
}

.FullScreenCallViewPanel__info-a99fe9 {
  grid-column-start: 1;
  grid-column-end: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  height: 48px;
  margin-top: -4px;
}

.FullScreenCallViewPanel__title-dcc668 {
  color: var(--addition-50);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}

.FullScreenCallViewPanel__call-state-ae9e6f {
  color: var(--addition-50);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}

.FullScreenCallViewPanel__actions-panel-d7b384 {
  height: 40px;
  grid-column-start: 2;
  grid-column-end: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.FullScreenCallViewPanel__call-actions-panel-fbbbcb {
  padding: 0;
}

.FullScreenCallViewPanel__additional-actions-dda103 {
  grid-column-start: 3;
  grid-column-end: 3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.FullScreenCallViewPanel__additional-actions-gap-bfa8d9 {
  margin-inline-end: 24px;
}

.FullScreenCallViewPanel__call-state-time-b6dc24 {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/FullScreenCallViewPanel/FullScreenCallViewPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,mCAAA;EACA,kBAAA;EACA,0FAAA;AACF;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AADF;;AAIA;EACE,uBAAA;AADF;;AAIA;EACE,SAAA;AADF","sourcesContent":[".container {\n  height: 40px;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  padding: 12px 24px;\n  background: linear-gradient(180deg, rgba(24, 25, 31, 0) 0%, rgba(24, 25, 31, 0.7) 227.27%);\n}\n\n.info {\n  grid-column-start: 1;\n  grid-column-end: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  height: 48px;\n  margin-top: -4px;\n}\n\n.title {\n  color: var(--addition-50);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  max-width: 280px;\n}\n\n.call-state {\n  color: var(--addition-50);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  max-width: 280px;\n}\n\n.actions-panel {\n  height: 40px;\n  grid-column-start: 2;\n  grid-column-end: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.call-actions-panel {\n  padding: 0;\n}\n\n.additional-actions {\n  grid-column-start: 3;\n  grid-column-end: 3;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.additional-actions-gap {\n  margin-inline-end: 24px;\n}\n\n.call-state-time {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FullScreenCallViewPanel__container-a11066`,
	"info": `FullScreenCallViewPanel__info-a99fe9`,
	"title": `FullScreenCallViewPanel__title-dcc668`,
	"call-state": `FullScreenCallViewPanel__call-state-ae9e6f`,
	"callState": `FullScreenCallViewPanel__call-state-ae9e6f`,
	"actions-panel": `FullScreenCallViewPanel__actions-panel-d7b384`,
	"actionsPanel": `FullScreenCallViewPanel__actions-panel-d7b384`,
	"call-actions-panel": `FullScreenCallViewPanel__call-actions-panel-fbbbcb`,
	"callActionsPanel": `FullScreenCallViewPanel__call-actions-panel-fbbbcb`,
	"additional-actions": `FullScreenCallViewPanel__additional-actions-dda103`,
	"additionalActions": `FullScreenCallViewPanel__additional-actions-dda103`,
	"additional-actions-gap": `FullScreenCallViewPanel__additional-actions-gap-bfa8d9`,
	"additionalActionsGap": `FullScreenCallViewPanel__additional-actions-gap-bfa8d9`,
	"call-state-time": `FullScreenCallViewPanel__call-state-time-b6dc24`,
	"callStateTime": `FullScreenCallViewPanel__call-state-time-b6dc24`
};
module.exports = ___CSS_LOADER_EXPORT___;
